import { Slot } from '@radix-ui/react-slot';
import { cn } from '@wwe-portal/ui/lib/lib';
import { FC } from 'react';
import glowingStyles from './glowing.module.css';

export interface GlowingProps extends React.ComponentPropsWithoutRef<'div'> {
  asChild?: boolean;
  active?: boolean;
}

export const Glowing: FC<GlowingProps> = ({
  asChild,
  className,
  onClick,
  active,
  ...props
}) => {
  const Comp = asChild ? Slot : 'div';
  return (
    <div className="relative">
      <Comp {...props} className={className} onClick={onClick} />
      {active && (
        <div
          className={cn(
            'pointer-events-none absolute inset-0 touch-none',
            glowingStyles.glowing
          )}
        />
      )}
    </div>
  );
};
